import styled from 'styled-components'

import { THEME } from '@constants/theme'

const CircularProgressRoot = styled.div<{ $size: number }>`
  display: inline-block;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  position: relative;
`

const SpinnerSvg = styled.svg<{ $size: number }>`
  display: block;
  animation: rotate 1.4s linear infinite;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`

const SpinnerCircle = styled.circle<{ $color: string }>`
  stroke: ${({ $color }) => $color};
  stroke-dasharray: 80, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash 1.4s ease-in-out infinite;

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 80, 200;
      stroke-dashoffset: -124;
    }
  }
`

function getColor(color: 'inherit' | 'primary' | 'secondary') {
  switch (color) {
    case 'primary':
      return THEME.colors.primary['50']
    case 'secondary':
      return THEME.colors.secondary['50']
    case 'inherit':
    default:
      return 'currentColor'
  }
}

export interface CircularProgressProps {
  className?: string
  color?: 'inherit' | 'primary' | 'secondary'
  size?: number
}

const SIZE = 44
const THICKNESS = 3.6

export function CircularProgress({ className, color = 'primary', size = 40, ...rest }: CircularProgressProps) {
  const spinnerColor = getColor(color)

  return (
    <CircularProgressRoot className={className} role="progressbar" aria-busy="true" $size={size} {...rest}>
      <SpinnerSvg $size={size} viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}>
        <SpinnerCircle
          $color={spinnerColor}
          cx={SIZE}
          cy={SIZE}
          r={(SIZE - THICKNESS) / 2}
          fill="none"
          strokeWidth={THICKNESS}
        />
      </SpinnerSvg>
    </CircularProgressRoot>
  )
}

export default CircularProgress
